import { ActionReducerMap } from '@ngrx/store';

import * as fromStoryblokGlobalContent from './storyblok-global-content';
import { StoryblokState } from './state';

export const reducers: ActionReducerMap<StoryblokState> = {
  storyblokGlobalContent: fromStoryblokGlobalContent.storyblokGlobalContentReducer,
};
